import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      // Constantes globais
      const CONFIG = {
        API_HEADERS: { 'Content-Type': 'application/json' },
        CART_ENDPOINT: '/api/front/cart/items/?version=2',
        SELECTORS: {
          cartPreview: '.cart-preview',
          shippingOverlay: '.cart-preview__shipping--overlay',
          shipping: '.cart-preview__shipping',
          shippingClose: '.cart-preview__shipping--close',
          itemsList: '.cart_preview-items',
          subtotal: '.cart-preview__sub-total--value',
          discounts: '.cart-preview__discounts--value',
          total: '.cart-preview__total--value',
          counters: '.new-quant_itens_carrinho',
          footer: '.cart-preview__footer',
          footerUtils: '.cart-preview__footer-utils',
          openUtils: '.open-utils',
          couponInput: '#appendedInputButton',
          removeCoupon: '#removeCoupon',
          shippingForm: '#js_form_shipping_cep_cart_lateral',
          cepInput: '#js_cep_input_cart_lateral',
          shippingList: '.cart-preview__shipping__list',
          selectedShipping: '.selected-shipping',
          // Seletores para a barra de progresso do frete grátis
          freeShippingBar: '.cart-preview-free-shipping__bar--percent',
          freeShippingValueFrom: '.cart-preview-free-shipping__value-from',
          freeShippingValueTo: '.cart-preview-free-shipping__value-to',
          freeShippingTip: '.cart-preview-free-shipping__tip'
        }
      };
      const handleZipCode = (event) => {
        let input = event.target;
        input.value = zipCodeMask(input.value);
      }

      const zipCodeMask = (value) => {
        if (!value) return "";
        value = value.replace(/\D/g, '');
        value = value.replace(/(\d{5})(\d)/, '$1-$2');
        return value;
      }
      const cepInput = document.querySelector('.cart-preview #js_form_shipping_cep_cart_lateral');
      if (cepInput) {
        cepInput.addEventListener('keyup', handleZipCode);
      }

      // Adiciona máscara para o input lateral também
      const cepInputLateral = document.querySelector(CONFIG.SELECTORS.cepInput);
      if (cepInputLateral) {
        cepInputLateral.addEventListener('keyup', handleZipCode);
      }


      // Funções utilitárias
      const utils = {
        formatCurrency: value => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value),

        toggleClasses: (selectors, className, add = true) => {
          selectors.forEach(selector => $(selector)[add ? 'addClass' : 'removeClass'](className));
        },

        addClasses: (selectors, className) => {
          selectors.forEach(selector => $(selector).addClass(className));
        },

        ajaxRequest: (method, url, data, headers = CONFIG.API_HEADERS) => {
          // Garantir que URLs de DELETE sempre tenham barra no final para evitar problemas no iOS 16.1
          let normalizedUrl = url;
          if (method === 'DELETE' && !url.endsWith('/')) {
            normalizedUrl = url + '/';
          }
          
          return $.ajax({
            type: method,
            url: normalizedUrl,
            headers,
            dataType: 'json',
            data: typeof data === 'object' ? JSON.stringify(data) : data
          });
        },

        updateFooterUtilsHeight: (first) => {
          const utils = document.querySelector(CONFIG.SELECTORS.footerUtils);
          if (utils) {
            utils.querySelectorAll('li').forEach(li => {
              const append = li.querySelector('.input-append');
              if (append) {
                const form = append.querySelector('form');
                const list = append.querySelector('.cart-preview__shipping__list');

                let totalHeight = 0;
                if (form) totalHeight += form.getBoundingClientRect().height;
                if (list) {
                  totalHeight += list.children.length > 0 ? 145 : 0;
                }

                append.style.height = `${totalHeight + 20}px`; // +20px de espaçamento
              }

              if (first) {
                li.classList.add('active');
              }
            });
          }
        },

        // Função para atualizar a barra de progresso do frete grátis
        updateFreeShippingProgress: (currentValue, targetValue, freeShippingLabel, freeShippingLabelSuccess) => {
          const { SELECTORS } = CONFIG;

          // Converter valores para números
          const current = parseFloat(currentValue) || 0;
          const target = parseFloat(targetValue) || 0;

          // Calcular a porcentagem
          let percentage = 0;
          if (target > 0) {
            percentage = Math.min((current / target) * 100, 100);
          }

          // Atualizar a barra de progresso
          const progressBar = document.querySelector(SELECTORS.freeShippingBar);
          if (progressBar) {
            progressBar.style.width = `${percentage}%`;
          }

          // Atualizar os valores exibidos
          const valueFrom = document.querySelector(SELECTORS.freeShippingValueFrom);
          const valueTo = document.querySelector(SELECTORS.freeShippingValueTo);

          if (valueFrom) {
            valueFrom.textContent = utils.formatCurrency(current);
          }

          if (valueTo) {
            // Se o valor atual ultrapassou o valor necessário, mostrar o valor atual em ambos
            const displayValue = current >= target ? current : target;
            valueTo.textContent = utils.formatCurrency(displayValue);
          }

          // Atualizar o texto da dica baseado no progresso
          const tipElement = document.querySelector(SELECTORS.freeShippingTip);
          if (tipElement && (freeShippingLabel || freeShippingLabelSuccess)) {
            // Se alcançou ou ultrapassou o valor mínimo, mostrar mensagem de sucesso
            if (current >= target && freeShippingLabelSuccess) {
              tipElement.innerHTML = freeShippingLabelSuccess;
            } else if (freeShippingLabel) {
              // Senão, mostrar mensagem normal
              tipElement.innerHTML = freeShippingLabel;
            }
          }
        }
      };

      // Inicialização de eventos
      const initEvents = () => {
        const { SELECTORS } = CONFIG;

        $(document).on('click', '.shipping--value', e => {
          e.preventDefault();
          utils.toggleClasses([SELECTORS.shippingOverlay, SELECTORS.shipping], 'active');
        });

        const cartShippingClose = document.querySelector(SELECTORS.shippingClose);
        const cartShippingOverlay = document.querySelector(SELECTORS.shippingOverlay);
        if (cartShippingClose && cartShippingOverlay) {
          [cartShippingClose, cartShippingOverlay].forEach(el =>
            el.addEventListener('click', () =>
              utils.toggleClasses([SELECTORS.shippingOverlay, SELECTORS.shipping], 'active', false)
            )
          );
        }

        $(SELECTORS.shippingForm).on('submit', handleShippingSubmit);
        bindCouponEvents();

        bindAjaxComplete();
      };

      // Renderização de item do carrinho
      const renderCartItem = (item, deleteId) => {
        const brand = item.brand ? `<p class="cart-item-content-brand">${item.brand}</p>` : '';
        const price = utils.formatCurrency(item.unit_price);
        const variation = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';
        const giftClass = item.is_gift ? 'is-gift' : '';

        const el = document.createElement('li');
        el.className = `cart-item ${giftClass}`;
        el.setAttribute('data-product-id', item.id);
        el.innerHTML = `
          <figure><img src="${item.image_medium}" alt="${item.name}"></figure>
          <div class="cart-item-content">
            ${brand}
            <h4 class="cart-item-content-name">${item.name}</h4>
            <p class="cart-item-content-price">${price}</p>
            <div class="variation-quantity">
              ${item.options.length > 0 ? `
                <select class="variation-select" data-original-id="${item.original_id}">
                  ${item.options.map(opt => `
                    <option 
                      value="${opt.product_id}" 
                      ${opt.product_id == item.original_id ? 'selected' : ''} 
                      ${!opt.available ? 'disabled' : ''}>
                        ${opt.value}
                    </option>
                  `).join('')}
                </select>
              ` : ''}
              <div class="group-quantity">
                <button class="btn-decrease" data-product="${item.original_id}" data-qtd="${item.quantity}">-</button>
                <span class="qtd-value">${item.quantity}</span>
                <button class="btn-increase" data-product="${item.original_id}" data-qtd="${item.quantity}">+</button>
              </div>
            </div>
            <button class="delete-item-button" data-original-id="${deleteId}"></button>
            
          </div>
        `;
        return el;
      };

      // Atualização dos contadores
      const updateCartCounters = (count, total, discount) => {
        const { SELECTORS } = CONFIG;
        const subtotal = Number(total) + Number(discount);

        document.querySelectorAll(SELECTORS.counters).forEach(el => {
          el.textContent = String(count).padStart(2, '0');
        });

        const elSubtotal = document.querySelector(SELECTORS.subtotal);
        if (elSubtotal) {
          elSubtotal.textContent = utils.formatCurrency(subtotal);
        }

        const elDuscount = document.querySelector(SELECTORS.discounts);
        if (elDuscount) {
          elDuscount.textContent = utils.formatCurrency(discount);
        }

        document.querySelector(SELECTORS.total).textContent = utils.formatCurrency(total);
      };

      // Vinculação de eventos do carrinho
      const bindCartEvents = () => {
        document.querySelectorAll('.delete-item-button').forEach(btn => {
          btn.onclick = () => deleteCartItem(btn.dataset.originalId);
        });

        document.querySelectorAll('.btn-increase').forEach(btn => {
          btn.onclick = () => {
            const qtd = parseInt(btn.dataset.qtd);
            updateItemQuantity(btn.dataset.product, qtd + 1);
          };
        });

        document.querySelectorAll('.btn-decrease').forEach(btn => {
          btn.onclick = () => {
            const qtd = parseInt(btn.dataset.qtd);
            qtd > 1
              ? updateItemQuantity(btn.dataset.product, qtd - 1)
              : deleteCartItem(btn.dataset.product);
          };
        });

        document.querySelectorAll('.variation-select').forEach(select => {
          select.addEventListener('change', function () {
            const selectedOption = this.options[this.selectedIndex];
            const newProductId = selectedOption.value;

            const cartItemEl = this.closest('.cart-item-content');
            const currentQty = parseInt(cartItemEl.querySelector('.qtd-value')?.textContent || 1, 10);

            const cartItem = this.closest('.cart-item');
            const itemId = cartItem.classList.contains('is-gift') ? cartItem?.querySelector('.delete-item-button')?.getAttribute('data-original-id') : cartItem?.getAttribute('data-product-id');
            const currentProductId = cartItem.querySelector('select')?.getAttribute('data-original-id');

            if (!itemId || !currentProductId || !newProductId) {
              console.error('IDs insuficientes para processar troca de variação.');
              return;
            }

            const payload = [{
              addon_values: "[]",
              as_free: false,
              is_buying_by_measure: false,
              item_id: itemId,
              product: currentProductId,
              new_product: newProductId,
              quantity: currentQty,
              replace_quantity: true
            }];

            $.ajax({
              type: 'POST',
              url: '/api/front/cart/items/?version=2',
              headers: { 'Content-Type': 'application/json' },
              dataType: 'json',
              data: JSON.stringify(payload)
            }).done(function (data) {
              if (data && data.cart_data && data.result) {
                updateCartPreview(data);
                select.setAttribute('data-original-id', newProductId);
              }
            }).fail(function (jqXHR, textStatus, errorThrown) {
              console.error('Erro ao trocar variação:', errorThrown);
              alert('Erro ao trocar o tamanho do produto.');
            });
          });
        });
      };

      // Atualização da pré-visualização do carrinho
      const updateCartPreview = (data) => {
        const { SELECTORS } = CONFIG;
        const container = document.querySelector(SELECTORS.cartPreview);
        if (!container) return;

        const currentTotal = data.cart_data.total_without_shipping || data.cart_data.total;
        if (data.cart_data.free_shipping_target) {
          // Esconde a faixa de frete se o target for '0.00'
          if (data.cart_data.free_shipping_target === '0.00' || data.cart_data.free_shipping_target === '0') {
            document.querySelectorAll('.cart-preview-free-shipping').forEach(el => el.classList.add('inactive'));
          } else {
            document.querySelectorAll('.cart-preview-free-shipping').forEach(el => el.classList.remove('inactive'));
          }
          utils.updateFreeShippingProgress(currentTotal, data.cart_data.free_shipping_target, data.cart_data.free_shipping_label, data.cart_data.free_shipping_label_success);
        }

        const list = container.querySelector(SELECTORS.itemsList);
        list.innerHTML = '';

        data.cart_data.items.forEach((item, index) => {
          const deleteId = data.result[index]?.id;
          list.appendChild(renderCartItem(item, deleteId));
        });

        updateCartCounters(data.result.length, data.cart_data.total_final, data.cart_data.total_discount);
        bindCartEvents();

        if (data.cart_data.coupon) {
          $(SELECTORS.couponInput).val(data.cart_data.coupon);
          $(SELECTORS.removeCoupon).addClass('active');
        }



        utils.updateFooterUtilsHeight(true);
      };

      // Recarregar pré-visualização
      const reloadCartPreview = () => {
        utils.ajaxRequest('GET', CONFIG.CART_ENDPOINT)
          .done(data => {
            if (data?.cart_data && data.result) {
              updateCartPreview(data);
            }
          });
      };

      // Remover item do carrinho
      const deleteCartItem = (id) => {
        utils.ajaxRequest('DELETE', '/api/front/cart/items/remove', [{ id }])
          .done(reloadCartPreview)
          .fail(err => console.log('Erro ao remover item do carrinho:', err));
      };

      // Atualizar quantidade do item
      const updateItemQuantity = (originalId, newQty) => {
        const payload = [{
          addon_values: "[]",
          as_free: false,
          is_buying_by_measure: false,
          product: originalId,
          quantity: newQty,
          replace_quantity: true,
        }];

        utils.ajaxRequest('POST', CONFIG.CART_ENDPOINT, payload)
          .done(data => {
            if (data?.cart_data && data.result) {
              updateCartPreview(data);
            }
          })
          .fail(jqXHR => {
            const data = jqXHR.responseJSON;
            if (Array.isArray(data) && data[0]?.stock) {
              alert(`O produto "${data[0].stock.product.name}" possui ${data[0].stock.quantity} unidade(s) em estoque.`);
            } else {
              alert('Ocorreu um erro inesperado ao atualizar a quantidade.');
            }
            console.log('Erro ao atualizar quantidade');
          });
      };

      // Vincular eventos de cupom
      const bindCouponEvents = () => {
        const { SELECTORS } = CONFIG;

        // Submit do cupom
        $('#js_form_coupon').on('submit', function (e) {
          e.preventDefault();
          const $form = $(this);
          const coupon = $form.find("input[name='coupon']").val();

          utils.ajaxRequest('PUT', '/api/front/cart/coupon/', { coupon })
            .done(() => {
              $(SELECTORS.removeCoupon).addClass('active');
              $form.removeClass('error').addClass('green').remove('invalid');
              // Recarregar a pré-visualização do carrinho para atualizar os valores
              reloadCartPreview();
            })
            .fail(() => {
              $form.removeClass('green').addClass('error').addClass('invalid');
            });
        });

        // Remoção do cupom
        $(SELECTORS.removeCoupon).on('click', function (e) {
          e.preventDefault();
          const $form = $('#js_form_coupon');

          utils.ajaxRequest('DELETE', '/api/front/cart/coupon/')
            .done(() => {
              $(SELECTORS.couponInput).val('');
              $(SELECTORS.removeCoupon).removeClass('active');
              $form.removeClass('green');
              reloadCartPreview();
            });
        });

        // Clique no input do cupom remove classes do form
        $('#js_form_coupon input[name="coupon"]').on('focus', function () {
          const $form = $('#js_form_coupon');
          $form.removeClass('green error invalid');
        });

      };

      // Manipular envio de frete
      const handleShippingSubmit = (e) => {
        e.preventDefault();
        const { SELECTORS } = CONFIG;
        const cep = $(SELECTORS.cepInput).val().replace(/['"]/g, ''); // Remove aspas simples ou duplas
        localStorage.setItem('cep', cep);

        const $loading = $('.shipping-loading');
        $loading.show();

        $.ajax({
          type: 'POST',
          url: '/produto/get-produto-frete/',
          data: { cep, show_delivery_shippings: true }, // Envia como form data, sem JSON
          dataType: 'json'
        }).done(data => {
          const shippings = data.shippings.shippings_available.shippings;
          const list = document.querySelector(SELECTORS.shippingList);
          if (!list) return;

          const hasMultiple = shippings.length > 1;

          const itemsHTML = shippings.map((s, i) => {
            let date = '';
            if (s.estimated_delivery_date != null && s.estimated_delivery_date !== '') {
              const [ano, mes, dia] = s.estimated_delivery_date.split('-');
              date = `${dia}/${mes}/${ano}`;
            }
            const cost = s.cost_label;

            return `
      <li class="cart-preview__shipping__list--item"
          data-index="${i}"
          data-shipping-id="${s.company_id}"
          data-shipping-cost="${cost}"
          data-shipping-name="${s.name}"
          data-shipping-price="${s.cost}"
          ${i > 0 ? 'style="display: none;"' : ''}>
        <div>
          <span>${s.name}</span>
          <span class="shipping--value">${cost}</span>
          <p>${s.delivery_time_days} ${s.label_delivery_time_days_checkout}</p>
          <p>Previsão ${date}</p>
        </div>
      </li>
    `;
          }).join('');

          const toggleBtn = hasMultiple
            ? `<button type="button" class="show-more-shippings" style="margin-top: 10px;">Ver mais opções de frete</button>`
            : '';

          list.innerHTML = itemsHTML + toggleBtn;

          requestAnimationFrame(() => {
            utils.updateFooterUtilsHeight(false);
          });

          if (hasMultiple) {
            const button = list.querySelector('.show-more-shippings');
            button?.addEventListener('click', () => {
              list.querySelectorAll('.cart-preview__shipping__list--item').forEach((li, i) => {
                if (i > 0) li.style.display = '';
              });
              button.style.display = 'none';
              utils.updateFooterUtilsHeight(false);
            });
          }
        })
          .fail(() => {
            alert('Erro ao calcular frete. Tente novamente.');
          })
          .always(() => {
            $loading.hide();
          });

      };

      // Vincular evento de conclusão de AJAX
      const bindAjaxComplete = () => {
        $(document).on("ajaxComplete", (event, xhr, settings) => {
          let payload = null;
  
          try {
            if (typeof settings.data === 'string') {
              payload = JSON.parse(settings.data);
            }
          } catch (err) {
            console.warn('settings.data não é um JSON válido:', settings.data);
            return; // early return para evitar seguir com payload inválido
          }
  
          if (
            settings.url.includes(CONFIG.CART_ENDPOINT) &&
            settings.type === 'POST' &&
            xhr.responseJSON?.result
          ) {
            reloadCartPreview();
            utils.toggleClasses(['.cart-preview--overlay'], 'active');
            utils.toggleClasses(['.cart-preview'], 'active');
            $('.shoppub-fast-buy-popup').removeClass('active');
            document.body.classList.toggle('no-scroll');
            document.documentElement.classList.toggle('no-scroll');
          }
        });
      };

      // Inicialização
      reloadCartPreview();
      initEvents();
    },
  },
  mounted() {
    this.cartPreview();

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        this.cartPreview();
      }
    });

    const allTitles = document.querySelectorAll('.cart-preview__footer-utils li');
    if (allTitles.length > 0) {
      allTitles.forEach(li => {
        const open = li.querySelector('.cart-preview__footer-utils--title');
        const toggleBtn = li.querySelector('.open-close');
        if (open && toggleBtn) {
          open.addEventListener('click', () => {
            li.classList.toggle('active');
            toggleBtn.classList.toggle('active');
          })
        }
      })
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
          if (mutation.attributeName === "class") {
              const target = mutation.target;
              if (target.classList.contains("active")) {
                  const elementsToRemove = target.querySelectorAll(".product-item__content--figure .product-item__options");
                  elementsToRemove.forEach(el => el.remove());
              }
          }
      });
  });
  
  document.querySelectorAll(".shoppub-fast-buy-popup").forEach(popup => {
      observer.observe(popup, { attributes: true, attributeFilter: ["class"] });
  }); 
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

document.addEventListener("DOMContentLoaded", function () {

  const containerShoppub = document.querySelector('#dynamic-page-extra .main-content .container-shoppub');
  if(containerShoppub) {
    const aboutStore = document.querySelector('#dynamic-page-extra #pagina-personalizada');
    if (aboutStore) {
      containerShoppub.classList.add('page-front');

      if($('.carrousel-photos')) {
        $('.carrousel-photos').slick({
          adaptiveHeight: true,
          arrows: true,
          initialSlide: 1,
          swipeToSlide: true, 
          touchThreshold: 100,
          dots: false,
          infinite: true,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 100,
        });
      }
    }
  }

  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {
    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var $el = $(el);
  
      if ($el.visible(true)) {
        $el.addClass("widget-loaded");
        $el.children().trigger("mouseenter");
      }
    });
  }
  

  $(window).on('scroll mousemove touchstart', function () {
    loadWidgets();
  });

  const overlay = document.querySelector('.header__product-item--options-overlay');
  const options = document.querySelector('.header__product-item--options');
  
  // Função para adicionar os eventos de clique aos botões de compra
  function addBuyButtonEvent() {
    const allProducts = document.querySelectorAll('.product-item');
  
    allProducts.forEach(element => {
      const button = element.querySelector('.buybox');
      const optionsElement = element.querySelector('.product-item__options');
      
      if (button && optionsElement) {
        button.addEventListener('click', () => {
          options.innerHTML = ''; // Limpa opções anteriores
          options.append(optionsElement.cloneNode(true)); // Clonando o optionsElement para evitar conflito
          overlay.classList.add('active');
          options.classList.add('active');
          b2bItens(); // Chama a função para configurar eventos nas opções
        });
      }
    });
  }
  
  // Usando delegação de eventos no contêiner pai dos produtos
  document.body.addEventListener('click', (event) => {
    const button = event.target.closest('.buybox');
  
    if (button) {
      const element = button.closest('.product-item');
      const optionsElement = element.querySelector('.product-item__options');
  
      if (optionsElement) {
        options.innerHTML = ''; // Limpa opções anteriores
        options.append(optionsElement.cloneNode(true)); // Clonando o optionsElement
        overlay.classList.add('active');
        options.classList.add('active');
        b2bItens(); // Chama a função para configurar eventos nas opções
      }
    }
  });
  
  // Lógica para fechar o overlay ao clicar no overlay
  if (overlay) {
    overlay.addEventListener('click', () => {
      overlay.classList.remove('active');
      options.classList.remove('active');
      options.innerHTML = ''; // Limpa opções ao fechar
    });
  }
  
  // Chame a função uma vez para os produtos já existentes
  addBuyButtonEvent();
  
  
  /* If Black Friday Template enabled */
  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });

  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  tabAccordions.forEach(function (tabAccordion, index) {
    tabAccordion.addEventListener('click', function () {
      tabAccordions.forEach(function (tab) {
        tab.classList.remove('active');
      });

      contentAccordions.forEach(function (content) {
        content.classList.remove('active');
      });

      tabAccordion.classList.add('active');
      contentAccordions[index].classList.add('active');
    });
  });

  waitForElementToExist('#carrousel-comunicado').then(element => {
    const comunicado = document.querySelector('.comunicado');
    if (comunicado) {
      $('#carrousel-comunicado').slick({
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplaySpeed: 3000,
        speed: 2000,
        responsive: [
          {
            breakpoint: 991,
            settings: "unslick"
          },
        ]
      });
    }
  });


  const aboutThemes = document.querySelector('.about-themes');
  if (aboutThemes) {
    $('#carrousel-second-section').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 2000,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick"
        },
      ]
    });
  }

  waitForElementToExist('.rotation-banners').then(element => {
    let rotationVitrine = document.querySelector('.rotation-banners');
    if (rotationVitrine) {
      let rotationNames = rotationVitrine.querySelectorAll('.rotation-banners__title a');
      let initVitrine = rotationVitrine.querySelectorAll('.rotation-banners__list .item');
      initVitrine = Array.from(initVitrine);
  
      if (rotationVitrine && rotationNames.length && initVitrine.length) {
        initVitrine[0].classList.add('active');
        rotationNames[0].classList.add('active');
  
        function activeTab(index) {
          initVitrine.forEach((content) => {
            content.classList.remove('active');
          });
          rotationNames.forEach((content) => {
            content.classList.remove('active');
          });
          initVitrine[index].classList.add('active');
          rotationNames[index].classList.add('active');
  
          $('.banner-masculino__list').slick('refresh');
          $('.banner-feminino__list').slick('refresh');
        }
  
        rotationNames.forEach((itemMenu, index) => {
          itemMenu.addEventListener('click', (e) => {
            e.preventDefault();
            activeTab(index);
          });
        })
      }
    }  

    $('.banner-masculino__list').slick({
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      responsive: [
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
          }
        }
      ]
    })

    $('.banner-feminino__list').slick({
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      responsive: [
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
          }
        }
      ]
    })
  });


  $("body").on("click", '.product-item__qtd__minus', function (event) {
    event.preventDefault();
    var $input = $(this).closest('.product-item__qtd').find('.product-item__qtd__text');
    var qtd = parseInt($input.val(), 10);

    if (qtd > 1) {
      qtd--;
      $input.val(qtd).attr('value', qtd);
    }
  });

  $("body").on("click", '.product-item__qtd__plus', function (event) {
    event.preventDefault();
    var $input = $(this).closest('.product-item__qtd').find('.product-item__qtd__text');
    var qtd = parseInt($input.val(), 10);

    qtd++;
    $input.val(qtd).attr('value', qtd);
  });

  $("body").on("click", '.not-available-grid', function (event) {
    event.preventDefault();
    var $input = $(this);
    let payload = [];
    payload.push({
      product: $input.attr('data-id'),
      quantity: 1,
      replace_quantity: true,
      is_buying_by_measure: false
    });

    if (payload.length > 0) {
      $.ajax({
        type: 'POST',
        url: '/api/front/cart/items/?version=2',
        data: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).fail(function (jqXHR, textStatus, errorThrown) {
        var data = jqXHR.responseJSON;
        for (var i in data) {
          if ('unavailable' in data[i]) {
            var d = data[i].unavailable;
            Swal.fire({
                imageUrl: d.product.image,
                html: '<strong>' + d.product.name + '</strong>' +
                    '<p>' + d.message + '</p>',
                input: 'text',
                inputPlaceholder: 'Informe seu e-mail:',
                showCancelButton: true,
                confirmButtonText: 'Cadastrar aviso',
                cancelButtonText: 'Cancelar',
                showLoaderOnConfirm: true,
                preConfirm: function (email) {
                    return new Promise(function (resolve, reject) {
                        product_detail_service.notify('', email, {}, d.product.id);
                        resolve();
                    });
                }
            });
          }
        };
      });
    }
  });

  function b2bItens() {
    // Função para converter uma string de moeda brasileira para número
    function parseBrazilianCurrency(value) {
      // Remove os pontos de milhar e substitui a vírgula decimal por um ponto
      value = value.replace(/\./g, '').replace(',', '.');
      // Converte para número float
      return parseFloat(value);
    }

    // Armazena o valor anterior dos inputs para calcular a diferença
    let previousValues = {};

    // Função genérica para aplicar a lógica em um contêiner específico
    function applyLogicToContainer(containerSelector) {
      // Aplica a lógica aos elementos dentro do contêiner
      const $container = $(containerSelector);

      if (!$container.find('.product-radio-variation.b2b').length) {
        addToCart($container);
        return;
      }

      $container.find('input[id^="product_item_variation__product_detail_"]').each(function () {
        // Inicializa o valor anterior no carregamento da página
        previousValues[$(this).attr('id')] = parseBrazilianCurrency($(this).attr('data-price')) * Number($(this).val());
      });

      $container.find('input[id^="product_item_variation__product_detail_"]').on('change', function () {
        var $el = $(this);

        // Obtém o ID do input
        const inputId = $el.attr('id');

        // Obtém o preço da variação do atributo data-price
        const variationPrice = parseBrazilianCurrency($el.attr('data-price'));

        // Obtém a quantidade da variação
        const variationQtd = Number($el.val());

        // Calcula o valor atual baseado no preço e na quantidade
        const currentValue = variationPrice * variationQtd;

        // Obtém o preço total atual e o converte para número
        const totalValue = parseBrazilianCurrency($container.find('.price-table').attr('data-price'));

        // Calcula a diferença entre o valor atual e o valor anterior
        const previousValue = previousValues[inputId] || 0;
        const difference = currentValue - previousValue;

        // Atualiza o valor total
        const newValue = totalValue + difference;

        // Atualiza o atributo data-price com o novo valor total
        $container.find('.price-table').attr('data-price', newValue.toFixed(2).replace('.', ','));

        // Atualiza o valor anterior para o próximo cálculo
        previousValues[inputId] = currentValue;
      });

      // Lógica para adicionar ao carrinho
      addToCart($container);

    }

    function addToCart(containerSelector) {
      const $container = $(containerSelector);
      $container.find('.b2b-button').click(function () {
        let payload = [];
        let isB2b = false;
        if ($container.find('.product-radio-variation').hasClass('b2b')) {
          isB2b = true;
          $container.find('input[id^="product_item_variation__product_detail_"]').each(function () {
            let $el = $(this);
            let value = Number($el.val());
            if (value > 0) {
              payload.push({
                as_free: false,
                product: Number($el.attr('data-id')),
                quantity: value,
                replace_quantity: true,
              });
            }
          });
        }else {
          let $el = $($container).find('input[id^="product_item_variation__product_detail_"]:checked');
          let value = Number($($container).find('.product-item__qtd input').val());
          if (value > 0) {
            payload.push({
              product: Number($el.attr('data-id')),
              quantity: value,
              replace_quantity: true,
              is_buying_by_measure: false
            });
          }
        }

        if (payload.length > 0) {
          let url;
          if(isB2b) {
            url = '/api/front/cart/items/?version=2&add_grid_by_conf=1';
          }else {
            url = '/api/front/cart/items/?version=2';
          }
          $.ajax({
            type: 'POST',
            url: url,
            data: JSON.stringify(payload),
            headers: { 'Content-Type': 'application/json' },
            dataType: 'json'
          }).done(function (data, textStatus, jqXHR) {
            if ($container.hasClass('product-detail__header--infoArea')) {
              if (conf_detalhe_produto_exibir_modal_continuar_comprando) {
                cart_preview.renderCartPreview();
                $("a.js-keeping-buying").fancybox().trigger('click');
              } else {
                location = url_carrinho;
              }
            } else {
              const overlay = document.querySelector('.header__product-item--options-overlay');
              const options = document.querySelector('.header__product-item--options');

              if (overlay && options) {
                overlay.classList.remove('active');
                options.classList.remove('active');
                options.innerHTML = '';
              }
            }
          }).fail(function (jqXHR, textStatus, errorThrown) {
            handleAjaxFail(jqXHR.responseJSON);
          });
        } else {
          alert('Por favor, selecione a quantidade.');
        }
      });
    }

    // Função para tratar falhas no AJAX
    function handleAjaxFail(data) {
      data.forEach(function (item) {
        if (item.stock) {
          alert(`O produto <strong>"${item.stock.product.name}"</strong> possui <strong>${item.stock.quantity}</strong> unidade(s) em estoque.`);
          return false;
        }

        if (item.limit_itens) {
          alert(item.limit_itens.message);
          return false;
        }

        if (item.buy_rules) {
          showBuyRulesWarning(item.buy_rules);
          return false;
        }
      });
    }

    // Função para exibir regras de compra
    function showBuyRulesWarning(buyRules) {
      let warning = `
      Quantidade solicitada para esta grade: <strong>${buyRules.quantity_total_grid_on_cart}</strong><br><br>
      Para o produto <strong>${buyRules.products[0].product_parent_or_self.name}</strong> é necessário comprar a grade conforme as regras abaixo:<br><br>
      <table class="behaviour-grid__table">
          <thead>
              <tr>
                  <th><strong>Total por grade</strong></th>
                  <th><strong>Total mínimo</strong></th>
                  <th><strong>Mínimo por variação</strong></th>
              </tr>
          </thead>
          <tbody>
  `;

      buyRules.grade_rules.forEach(function (rule) {
        let isCurrentRule = parseInt(buyRules.quantity_total_grid_on_cart) === parseInt(rule.total_quantity_that_must_be_purchased_in_the_grid);
        warning += `
          <tr${isCurrentRule ? ' style="color:red; text-decoration: underline;"' : ''}>
              <td>${formatRuleQuantity(rule.total_quantity_that_must_be_purchased_in_the_grid, rule.total_quantity_must_be_multiple_of_itself)}</td>
              <td>${formatRuleQuantity(rule.minimum_amount_that_must_be_purchased_in_the_grid)}</td>
              <td>${formatRuleQuantity(rule.minimum_amount_that_must_be_purchased_by_product, rule.minimum_amount_must_be_multiple_of_itself, rule)}</td>
          </tr>
      `;
      });

      warning += '</tbody></table>';
      alert(warning);
    }

    // Formatação das quantidades de regras
    function formatRuleQuantity(quantity, isMultiple = false, rule = null) {
      if (!quantity) return 'sem limite';
      let formatted = isMultiple ? `múltiplo de ${quantity}` : `${quantity}`;
      if (rule) {
        if (!rule.close_grid) formatted += ' (grade aberta)';
        else formatted += ` (grade fechada${rule.variations_not_required ? ` (não obrigatório: ${rule.variations_not_required.split(",").join(", ")})` : ''})`;
      }
      return formatted;
    }

    // Executa a função para os dois contextos diferentes
    applyLogicToContainer('.product-detail__header--infoArea');
    applyLogicToContainer('.header__product-item--options');

  }

  b2bItens();

});

const pageExtraCarrosel = document.querySelector('#dynamic-page-extra .image-list');
if (pageExtraCarrosel) {
  $('#dynamic-page-extra .image-list').slick({
    arrows: false,
    dots: false,
    infinite: false,
    autoplay: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 2000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
    ]
  });
}